import { isEmpty, isEqual, isUndefined } from 'lodash';
import { useContext, useEffect, useState } from 'react';

import { FiltersModel, ProductsModel } from '../interface/products';
import { ProductContext } from '../context/Products/context';
import { DispatchEvents } from '../enums/dispatchEvent';

export function useFilterProducts(
  products: ProductsModel[],
  categoryFilters: FiltersModel
) {
  const [filteredProducts, setFilteredProducts] = useState(products);
  const [trigger, setTrigger] = useState(false);
  const [clearFilters, setClearFilters] = useState(false);
  const { state, dispatch } = useContext(ProductContext);

  function handleSelectFilter(
    filterType: string,
    filterValue: string,
    status: boolean
  ) {
    const categoryFilterGroup = state.categoryFilters.find(
      (cateogryFilterGroup: any) => cateogryFilterGroup.type === filterType
    ) as any;
    const categoryFilter = categoryFilterGroup?.options.find(
      (categoryFilter: any) => categoryFilter.value === filterValue
    );
    categoryFilter.checked = status;
    setTrigger(!trigger);
  }

  function handleClearFilters() {
    setClearFilters(!clearFilters);
  }

  useEffect(() => {
    const categoryFilterGroups = [];
    for (const filter in categoryFilters.attributes.filters) {
      !isEmpty(categoryFilters.attributes.filters[filter]) &&
        categoryFilterGroups.push({
          type: filter,
          options: categoryFilters.attributes.filters[filter].map(
            (filterItem: any) => {
              return {
                value: filterItem.WebsiteDisplayName,
                checked: false
              };
            }
          )
        });
    }
    dispatch({
      type: DispatchEvents.SET_CATEGORY_FILTERS,
      payload: categoryFilterGroups
    });
  }, [categoryFilters, clearFilters]);

  // Will refactor on PHASE 2
  useEffect(() => {
    const filterStatusList: any[] = [];
    state.categoryFilters.forEach((categoryFilter: any) => {
      categoryFilter.options.forEach((option: any) =>
        filterStatusList.push(option.checked)
      );
    });

    const filterProductsList = products.filter((product: any) => {
      const activeFilters: any[] = [];
      const isPassed = state.categoryFilters.map((categoryFilter: any) => {
        return {
          type: categoryFilter.type,
          passed: false
        };
      });

      state.categoryFilters.forEach((filter: any) => {
        filter.options
          .filter((option: any) => option.checked === true)
          .forEach((option: any) =>
            activeFilters.push({ type: filter.type, value: option.value })
          );

        const activeItem = isPassed.find((item) =>
          isEqual(item.type, filter.type)
        ) as any;

        const activeFeaturesFilter = state.categoryFilters.find(
          (categoryFilter: any) => isEqual(categoryFilter.type, 'features')
        ) as any;

        const numberOfActiveFeaturesFilter =
          activeFeaturesFilter?.options?.filter(
            (option: any) => option.checked === true
          ).length;

        if (
          numberOfActiveFeaturesFilter > 1 &&
          isEqual(filter.type, 'features')
        ) {
          if (isEqual(numberOfActiveFeaturesFilter, 2)) {
            if (
              !activeFilters.map((filter) => filter.type).includes(filter.type)
            ) {
              activeItem.passed = true;
            } else {
              if (
                (activeFilters
                  .map((options) => options.value)
                  .includes(
                    product.attributes.filters?.[filter.type][0]
                      ?.WebsiteDisplayName
                  ) &&
                  activeFilters
                    .map((options) => options.value)
                    .includes(
                      product.attributes.filters?.[filter.type][1]
                        ?.WebsiteDisplayName
                    )) ||
                (activeFilters
                  .map((options) => options.value)
                  .includes(
                    product.attributes.filters?.[filter.type][0]
                      ?.WebsiteDisplayName
                  ) &&
                  activeFilters
                    .map((options) => options.value)
                    .includes(
                      product.attributes.filters?.[filter.type][2]
                        ?.WebsiteDisplayName
                    )) ||
                (activeFilters
                  .map((options) => options.value)
                  .includes(
                    product.attributes.filters?.[filter.type][1]
                      ?.WebsiteDisplayName
                  ) &&
                  activeFilters
                    .map((options) => options.value)
                    .includes(
                      product.attributes.filters?.[filter.type][2]
                        ?.WebsiteDisplayName
                    ))
              ) {
                activeItem.passed = true;
              } else {
                activeItem.passed = false;
              }
            }
          }
          if (isEqual(numberOfActiveFeaturesFilter, 3)) {
            if (
              !activeFilters.map((filter) => filter.type).includes(filter.type)
            ) {
              activeItem.passed = true;
            } else {
              if (
                activeFilters
                  .map((options) => options.value)
                  .includes(
                    product.attributes.filters?.[filter.type][0]
                      ?.WebsiteDisplayName
                  ) &&
                activeFilters
                  .map((options) => options.value)
                  .includes(
                    product.attributes.filters?.[filter.type][1]
                      ?.WebsiteDisplayName
                  ) &&
                activeFilters
                  .map((options) => options.value)
                  .includes(
                    product.attributes.filters?.[filter.type][2]
                      ?.WebsiteDisplayName
                  )
              ) {
                activeItem.passed = true;
              } else {
                activeItem.passed = false;
              }
            }
          }
        } else {
          if (
            !activeFilters.map((filter) => filter.type).includes(filter.type)
          ) {
            activeItem.passed = true;
          } else {
            if (
              activeFilters
                .map((options) => options.value)
                .includes(
                  product.attributes.filters?.[filter.type][0]
                    ?.WebsiteDisplayName
                ) ||
              activeFilters
                .map((options) => options.value)
                .includes(
                  product.attributes.filters?.[filter.type][1]
                    ?.WebsiteDisplayName
                ) ||
              activeFilters
                .map((options) => options.value)
                .includes(
                  product.attributes.filters?.[filter.type][2]
                    ?.WebsiteDisplayName
                )
            ) {
              activeItem.passed = true;
            } else {
              activeItem.passed = false;
            }
          }
        }
      });

      const firstFilter = !isUndefined(isPassed?.[0]?.passed)
        ? isPassed?.[0]?.passed
        : true;
      const secondFilter = !isUndefined(isPassed?.[1]?.passed)
        ? isPassed?.[1]?.passed
        : true;
      const thirdFilter = !isUndefined(isPassed?.[2]?.passed)
        ? isPassed?.[2]?.passed
        : true;
      const fourthFilter = !isUndefined(isPassed?.[3]?.passed)
        ? isPassed?.[3]?.passed
        : true;
      const fifthFilter = !isUndefined(isPassed?.[4]?.passed)
        ? isPassed?.[4]?.passed
        : true;
      const sixthFilter = !isUndefined(isPassed?.[5]?.passed)
        ? isPassed?.[5]?.passed
        : true;
      const seventhFilter = !isUndefined(isPassed?.[6]?.passed)
        ? isPassed?.[6]?.passed
        : true;
      const eighthFilter = !isUndefined(isPassed?.[7]?.passed)
        ? isPassed?.[7]?.passed
        : true;

      return (
        firstFilter &&
        secondFilter &&
        thirdFilter &&
        fourthFilter &&
        fifthFilter &&
        sixthFilter &&
        seventhFilter &&
        eighthFilter
      );
    });

    if (filterStatusList.every((status) => isEqual(status, false)))
      setFilteredProducts(products);
    else setFilteredProducts(filterProductsList);
  }, [trigger, state.categoryFilters]);

  return { filteredProducts, handleClearFilters, handleSelectFilter };
}
